<template>
  <div id="calender-page">
    <tab-header :key="$route.path" :id="2" :ex="4" :mode="true"/>
    <div id="calender-container">
      <div class="calender_title">
        <h1>교육일정</h1>
      </div>
    <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar
          flat
        >
          <v-btn
            outlined
            class="mr-4"
            color="grey darken-2"
            @click="setToday"
          >
            Today
          </v-btn>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="prev"
          >
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="next"
          >
            <v-icon small>
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            text
            outlined
            class="add mr-5"
            style="border:1px solid #2156d0"
            @click="openEventDialog(focus)"
            v-if="isAuth && getUser.per_edu"
          >일정 추가하기
          </v-btn>
          <v-menu
            bottom
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                color="grey darken-2"
                v-bind="attrs"
                v-on="on"
              >
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>일간</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>주간</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>월간</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :type="type"
          :event-color="getEventColor"
          :event-overlap-mode="'stack'"
          :event-overlap-threshold="30"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
          max-width="400px"
        >
          <v-card
            color="grey lighten-4"
            max-width="400px"
            flat
          >
            <v-toolbar
              :color="selectedEvent.color"
              dark
            >
              <v-btn icon>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <span v-html="selectedEvent.details"></span>
            </v-card-text>
            <v-card-actions>
              <v-btn
                text
                color="secondary"
                @click="selectedOpen = false"
              >
                취소
              </v-btn>
              <v-btn
                text
                color="secondary"
                @click="deleteEvent"
                v-if="isAuth && getUser.per_edu"
              >
                삭제
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
    <schedule-dialog/>
  </div>
  <app-footer class="footer"/>
  </div>
</template>

<script>
import AppFooter from '../../../components/utils/AppFooter.vue'
import TabHeader from '../../../components/utils/common/TabHeader.vue'
import ScheduleDialog from '../../../components/utils/modal/ScheduleDialog.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    TabHeader,
    AppFooter,
    ScheduleDialog
  },
  name: 'Calender',
  data: () => ({
    focus: '',
    type: 'month',
    typeToLabel: {
      month: '월간',
      week: '주간',
      day: '일간'
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    title: null
  }),
  mounted () {
    // this.$store.dispatch('home/fetchEventList')
    this.title = this.$refs.calendar.title
  },
  computed: {
    ...mapGetters('auth', ['isAuth', 'getUser']),
    events () {
      return this.$store.state.home.events
    }
  },
  methods: {
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    openEventDialog (date) {
      this.$store.commit('home/openCalendarDialog', date)
    },
    setToday () {
      this.focus = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    getEventColor (event) {
      return event.color
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        setTimeout(() => {
          this.selectedOpen = true
        }, 10)
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }
      nativeEvent.stopPropagation()
    },
    deleteEvent () {
      const se = this.selectedEvent
      const fidx = this.events.findIndex((item) => {
        return item.name === se.name && item.start === se.start && item.end === se.end
      })
      this.$store.state.home.events.splice(fidx, 1)
      this.$store.dispatch('home/updateEventList')
      this.selectedOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
button.add.v-btn{
  font-size: 1.1rem !important;
  border-radius: 5px;
  border: 2px solid #2156d0;
  padding: 10px;
  color: #2156d0;
}
#calender-page{
  height: 1340px;
  .footer{
      position: absolute;
      bottom: 0px;
      width:100%;
  }
}
#calender-container{
    position: absolute;
    width: 90%;
    top: 300px;
    left: 50%;
    padding: 10px;
    transform: translateX(-50%);
    .calender_title{
      width: 80%;
      margin: 0 auto;
      text-align: center;
      h1{
        text-align: center;
        font-size: 2.5rem;
        padding-bottom: 30px;
      }
      hr{
        width: 30%;
        margin: 0 auto;
        border-color: #6098FF;
        background-color: #5e82c5;
      }
    }
}

</style>
